<template>
  <v-container
    :fluid="$vuetify.breakpoint.smAndDown"
    class="ak-classes-list pb-10"
    :class="{ 'pt-10': $vuetify.breakpoint.smAndUp }"
  >
    <AKAccessDeniedMessage v-if="accessDenied" />
    <template v-else>
      <v-row no-gutters>
        <v-col cols="12" class="mt-5 d-flex justify-start align-center">
          <AKButton
            @click="goBackHome()"
            icon="ArrowLeft"
            :height="$vuetify.breakpoint.mdAndDown ? '34' : '38'"
            :width="$vuetify.breakpoint.mdAndDown ? '40' : '51'"
            class="goBackBtn"
          />
          <h2 class="ak-colorText-white font-protext font30-600 mr-5">
            Klassen
          </h2>
          <v-btn text color="#fff" class="px-0 pr-2" @click="addNewClass()">
            <mdicon class="ak-icon pr-3" name="PlusCircle" size="34" />
            Klasse hinzufügen
          </v-btn>
        </v-col>
        <v-col cols="12">
          <template v-if="classesList.length > 0">
            <v-text-field
              color="#fff"
              v-model="classSearch"
              append-icon="mdi-magnify"
              label="Suche"
              single-line
              solo
              hide-details
              class="mt-4"
            />
            <v-data-table
              :headers="headers"
              :items="classesList"
              item-key="name"
              class="elevation-0 my-5"
              :search="classSearch"
              :footer-props="{
                'items-per-page-text': 'Anzahl Ergebnisse',
                'items-per-page-options': [12, 24, 36, 48, -1],
              }"
              :options="optionsTable"
              @click:row="rowClick"
            />
          </template>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import AKAccessDeniedMessage from '@/components/common/AKAccessDeniedMessage';
import AKButton from '@/components/common/core/AKButton';
import CommonMixins from '@/mixins/CommonMixins';

export default {
  name: 'ClassesList',
  components: { AKButton, AKAccessDeniedMessage },
  mixins: [CommonMixins],
  data() {
    return {
      classSearch: '',
      classesList: [],
    };
  },

  computed: {
    headers() {
      return [{ text: 'Name Klasse', value: 'name', sortable: false }];
    },
  },

  created() {
    this.$axios
      .get('/api/v1/admin/classes/', this.axiosGetConfig)
      .then((res) => {
        if (res.data.data) {
          res.data.data.forEach((item) => {
            this.classesList.push({
              id: item.data.id,
              name: item.data.name,
            });
          });
        }
      });
  },
  methods: {
    rowClick(val) {
      this.goTo(val.id, val.name);
    },

    searchText(value, classSearch) {
      return (
        value != null &&
        classSearch != null &&
        typeof value === 'string' &&
        value.toString().indexOf(classSearch) !== -1
      );
    },

    goTo(id, name) {
      if (id !== null) {
        this.$router
          .push({
            name: 'AddClass',
            params: { classId: id, className: name, from: 'ClassesList' },
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    addNewClass() {
      this.$router
        .push({ name: 'AddClass', params: { from: 'ClassesList' } })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ak-classes-list {
  height: 100%;
  position: relative;
  @media (min-width: map-get($grid-breakpoints, sm)) {
    max-width: 530px;
  }
}
.ak-section-title {
  font-family: 'SFProText';
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #f1f0ec;
  margin-bottom: 25px;
  text-align: center;
}

::v-deep .v-btn__content {
  text-transform: none !important;
  letter-spacing: 0px !important;
}
</style>
